module.exports = __webpack_public_path__ + "static/media/blob-food-cart.4ea38e3f.svg";